"use client";
import React from "react";
import { motion } from "framer-motion";
import SectionHeading from "../../SectionHeading";
import Spacing from "../../Spacing";
import Feature from "../../Feature";
import "./FeaturesSection.scss";

export default function FeaturesSection({ sectionTitle, data }) {
  return (
    <section className="cs_celbion">
      {/* 🔵 TOP HERO */}
      <div className="cs_celbion_hero">
        <div className="container">
          <div className="cs_celbion_hero_in">
            <div className="rocketHero__content">
              <h2>
                WHY <br />
                <span>CELBION</span> <br />
                WAS
                <br />
                LAUNCHED
              </h2>
              <span className="rocketHero__question">?</span>
            </div>

            {/* <div className="cs_celbion_right">
              <motion.img
                src="/images/rocket.png"
                alt="rocket"
                initial={{ y: 0 }}
                animate={{ y: [-10, 10, -10] }}
                transition={{ duration: 3, repeat: Infinity }}
              />
            </div> */}

            <div className="rocketHero__visual">
              {/* ROCKET */}
              <div className="rocketHero__rocket">
                <img src="/images/rocket.png" alt="rocket" />
              </div>

              {/* FLOATING ICONS */}
              <div className="rocketHero__icon icon1">
                <img src="/images/settings.png" alt="Icon 1" />
              </div>
              <div className="rocketHero__icon icon2">
                <img src="/images/target.png" alt="Icon 2" />
              </div>
              <div className="rocketHero__icon icon3">
                <img src="/images/brain.png" alt="Icon 3" />
              </div>
              <div className="rocketHero__icon icon4">
                <img src="/images/light-bulb.png" alt="Icon 4" />
              </div>
              <div className="rocketHero__icon icon5">
                <img src="/images/trend.png" alt="Icon 5" />
              </div>
            </div>
          </div>
        </div>

        <div className="rocketHero__cloud">
          {/* <img src="/images/cloud.png" alt="Cloud" /> */}
        </div>
      </div>

      {/* ⚪ CONTENT AREA */}
      <div className="cs_shape_wrap">
        <div className="cs_shape_1" />

        <div className="container">
          <SectionHeading title={sectionTitle} center />

          <div className="cs_section__title_subtitle mt-0">
            <h4>Why Celbion Healthcare Was Conceived</h4>
            <p>
              The landscape of neurological, psychiatric, cognitive and
              pain-related disorders is rapidly evolving. Chronic diseases
              require
              <b> long-term, rational, and safe therapeutic strategies</b>{" "}
              rather than short-term symptomatic fixes.
            </p>
          </div>

          <Spacing md="72" lg="50" />

          {/* 🔽 FEATURES (YOUR COMPONENT) */}
          {/* <div className="cs_celbion_steps">
            {data?.map((item, index) => (
              <div className="cs_celbion_step" key={index}>
                <div className="cs_step_label">{item.title}</div>
                <div className="cs_step_card">
                  <Feature {...item} />
                </div>
              </div>
            ))}
          </div> */}
        </div>
      </div>
    </section>
  );
}
